import actions from "../../constants/actions";

export const loadPage = (key) => {
    return {
        type: actions.PAGES.LOAD,
        payload: {
            key,
        },
    };
};
